import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'antd';
import { Header } from 'antd/es/layout/layout';
import BrandLogo from '../assets/images/logo-light.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';
import { themecolor } from '../config.js';

import arrow from '../../src/assets/images/back_arrow.svg';
import { MenuUnfoldOutlined } from '@ant-design/icons';

import settingsIcon from '../../src/assets/images/setting_icon.png';
import notificationIcon from '../../src/assets/images/notification_icon_dark.png';
import { useDispatch, useSelector } from 'react-redux';
import { businessInfo } from '../slices/businessInfo/thunk.js';
import { getNotificationUnreadCount } from '../slices/notificationAll/thunk.js';

import { ShimmerTitle } from 'react-shimmer-effects';
import Avatar from '../pages/Components/Avatar/Avatar.jsx';
import Share from '../Common/Share/ShareComponent.jsx';


const StyleHeader = styled(Header)`
  padding-inline: 24px;
  position: fixed;
  left: ${({ theme }) => theme.direction === 'rtl' ? '0' : `${themecolor.components.Menu.verticalSidebarWidth}px`};
  right: ${({ theme }) => (theme.direction === 'rtl' ? `${themecolor.components.Menu.verticalSidebarWidth}px` : '0')};
  top: 0;
  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.token.colorBorder};
  z-index: 999;
  background: ${({ theme }) => theme.token.colorBgContainer};
  
  @media screen and (max-width: 768px) {
    /* Apply the responsive style without considering RTL or LTR */
    left: 0;
    right: 0;
  }
`;

const HeaderContainer = styled.ul`
  font-size: 15px;
  padding-inline: 0;
  display: flex;
  gap: 10px;
  margin: 0;
  justify-content: end;

  .ant-avatar {
    background-color: transparent;
    transition: all 0.5s ease;
    &:hover {
        background-color: ${({ theme }) => theme.token.colorBorder};
    }
  }
`;




const HeaderLayout = ({ darkMode, handleToggleMode }) => {
    const [isClick, setIsClick] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const navigate = useNavigate();
    const location = useLocation();
    const [visiblePath, setVisiblePath] = useState('');
    const notificationCount = useSelector((state) => state.NotificationAll.unreadCount);
    const dispatch = useDispatch();
    const [showShimmer , setShowShimmer] = useState(false);

    useEffect(() => {
        // Fetch unread notification count when header loads
        dispatch(getNotificationUnreadCount());
        setIsClick(false);
        updateWindowDimensions();
        window.addEventListener('resize', updateWindowDimensions);

        return () => {
            window.removeEventListener('resize', updateWindowDimensions);
        };

    }, [dispatch]);

    useEffect(()=>{
        dispatch(businessInfo()); // This now fetches bureau data

    },[location, dispatch])

    // useEffect(()=>{
    //     dispatch(getDashboard());
    // },[location.pathname, dispatch])

    const dashboardData = useSelector((state)=>state.Dashboard);

    useEffect(()=>{
        if(dashboardData){
          if(dashboardData?.data?.profile_verified_admin === true){
            localStorage.setItem('isVerified', true);
          }else{
            localStorage.setItem('isVerified', false);
          }  
        }
    
      },[dashboardData , dispatch ])
    
    const businessInfoData = useSelector((state) => state.BusinessInfoReducer)
    // businessInfo now contains bureau data

    useEffect(() => {
        pathUpdate(location.pathname);
        // Refresh notification count when navigating away from notifications page
        if (location.pathname !== '/notifications') {
            dispatch(getNotificationUnreadCount());
        }
    }, [location.pathname, dispatch]);

    const updateWindowDimensions = () => {
        setWindowWidth(window.innerWidth);
    };

    const handleToggleButton = () => {
        setIsClick(prevIsClick => !prevIsClick);
        const sidebarLayout = document.getElementById('sidebar-layout');
        sidebarLayout.style.display = isClick ? 'none' : 'block';
    };

    useEffect(() => {
        const sidebarLayout = document.getElementById('sidebar-layout');
        if (sidebarLayout) {
            if (windowWidth < 768) {
                sidebarLayout.style.display = 'none';
            } else {
                sidebarLayout.style.display = 'block';
            }
        }
    }, [windowWidth]);

    const pathUpdate = (pathname) => {
        const lastWord = pathname.split('/').pop();
        switch (lastWord) {
            case 'new-ads':
                setVisiblePath('Manage Ad');
                break;
            default:
                setVisiblePath(pathname.slice(1));
                break;
        }
    };
    let split = visiblePath.split('/');

    useEffect(() => {
        // Set a timeout to hide the shimmer after 400 seconds (400,000 milliseconds)
        const timer = setTimeout(() => {
          setShowShimmer(false);
        }, 400000);
    
        // Clear the timeout if the component is unmounted
        return () => clearTimeout(timer);
      }, []);


    useEffect(()=>{
       console.log('Business info (bureau data):', businessInfoData?.businessInfo)
       // Handle bureau data for display
       if (businessInfoData?.businessInfo && Object.keys(businessInfoData.businessInfo).length > 0) {
           // Bureau data is available for use
       }
    },[businessInfoData?.businessInfo])

    // user verification '

    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //       setShowShimmer(false);
    //     }, 3000);
    
    //     return () => clearTimeout(timer);
    //   }, []);




    return (
        <React.Fragment>
            <StyleHeader id="antHeaderMain" className='header' >
                <Row align="middle" className='nav_wrapper' gutter={[16, 24]}>
                    {windowWidth < 768 && (
                        <Col>
                            <img src={BrandLogo} height={24} style={{ display: 'none' }} alt='' />
                            <Button type='primary' className='collapse_btn' onClick={handleToggleButton}><MenuUnfoldOutlined /></Button>
                        </Col>
                    )}
                    <div className='main_logo_wrap'>
                        {location.pathname === '/dashboard' ? (
                            <div className='location'>
                                <Avatar>{businessInfoData?.businessInfo?.name?.[0] || 'B'}</Avatar>


                                <div className='cnt'>
                                    <span style={{fontWeight: "600" }} className='text_md2 text_capitalize'>{businessInfoData?.businessInfo?.name || 'Bureau Name'}</span>
                                    {/* <span className='app__category'>Marriage Bureau</span> */}
                                    <span className="app__location">{businessInfoData?.businessInfo?.address || 'Address'}</span>
                                </div>
                            </div>
                        ) : (
                            <div className='back_cnt' style={{ display: "flex", alignItems: "center" }}>
                                {/* <Button
                                    className='default_remove back_button'
                                    style={{ display: "flex", padding: 0, marginLeft: "17px"}}
                                    onClick={() => {
                                        // Smart back navigation based on current route
                                        console.log('location' , location)
                                        const pathParts = location.pathname.split('/');
                                        
                                        if (pathParts[1] === 'profile-details' && pathParts[2]) {
                                            // From profile-details/{id} -> navigate to profile-creation/{id} for editing
                                            console.log('Navigating from profile-details to profile-creation')
                                            navigate(`/profile-creation/${pathParts[2]}`);
                                        } else if (pathParts[1] === 'profile-creation' && pathParts[2]) {
                                            // From profile-creation/{id} -> navigate to my-profiles (listing page)
                                            console.log('Navigating from profile-creation with ID to my-profiles')
                                            navigate('/my-profiles');
                                        } else {
                                            // Default back navigation
                                            navigate(-1);
                                        }
                                    }}
                                >
                                    <img src={arrow} alt='' className='img_full contain' />
                                </Button> */}
                               
                                <p style={{ marginBottom: 0, textTransform: "capitalize", transition: '.4s', fontSize: 'calc(15px + .5vw )' , lineHeight: 1.5 }}>
                               {
                                showShimmer && (
                                    <div className='header_title_shimmer'>
                                    <ShimmerTitle line={1} gap={10} />
                                </div>
                                )
                               }
                                {split[0] === 'live-ads' ? (
                                        <div className='title_support'>
                                            <span>{'Profile Details'}</span>
                                            {/* { split[1] &&  <span className='md'> <span>Ad ID :</span>&nbsp;{split[1]}</span>} */}
                                        </div>
                                    ) : split[0] === 'profile-details' ? (
                                        <div className='title_support'>
                                            <span>Profile Preview</span>
                                        </div>
                                    ) : (
                                        visiblePath.replace('-' , ' ')
                                    )}
                                </p>
                            </div>
                        )}
                    </div>
                    <Col className='ant-ml-auto'>
                        <HeaderContainer className='ant-topbar-head list-unstyled'>
                            {/* <li>
                                <Share className='header_share' type='bureau' />
                            </li> */}
                            <li>
                                <Link to='/notifications' className='notification_link'>
                                    <img src={notificationIcon} alt='notification' />
                                    {
                                        (location.pathname !== '/notifications' && notificationCount !== 0 ) &&  <span className='notification_count'>{notificationCount > 99 ? '99+' : notificationCount}</span>
                                    }
                                   
                                </Link>
                            </li>
                            <li>
                                <Link to='/settings'>
                                    <img src={settingsIcon} alt='settings' />
                                </Link>
                            </li>
                        </HeaderContainer>
                    </Col>
                </Row>
                
            </StyleHeader>
        </React.Fragment>
    );
};

export default HeaderLayout;
